<section class="container portal-category py-4">
  <div class="row g-4">
    <div class="col-12">
      <div class="card shadow-sm">
        <div class="card-header d-flex justify-content-between align-items-center"><span>{{ title }}</span><small class="text-body-secondary">Seleccione una tarjeta para filtrar</small></div>
        <div class="card-body">
          @if (loading()) { <p class="text-body-secondary mb-0">Cargando información...</p> }
          <div class="row g-3">
            @for (item of categoryItems(); track item.id) {
              <div class="col-6 col-md-4 col-lg-3 col-xl-2">
                <button class="card category-item-card h-100 w-100" type="button" [class.border-primary]="selectedId() === item.id" [class.shadow]="selectedId() === item.id" (click)="selectCategory(item.id)">
                  <div class="card-body text-center d-flex flex-column align-items-center gap-2">
                    @if (imageSource(item.image); as image) { <img class="category-item-image" [src]="image" alt="" /> } @else { <span class="category-item-placeholder"><i class="bi bi-image"></i></span> }
                    <span class="small fw-semibold">{{ item.label }}</span>
                  </div>
                </button>
              </div>
            } @empty { @if (!loading()) { <p class="text-body-secondary mb-0">No hay registros disponibles.</p> } }
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="card shadow-sm">
        <div class="card-header d-flex justify-content-between align-items-center"><span>Productos</span><small class="text-body-secondary">{{ filteredProducts().length }} resultados</small></div>
        <div class="card-body">
          <div class="row g-3">
            @for (product of filteredProducts(); track product.id) {
              <div class="col-12 col-md-6 col-xl-4">
                <article class="card product-card h-100" [class.border-danger]="hasDiscount(product)" [class.border-2]="hasDiscount(product)">
                  <div class="card-body d-flex flex-column">
                    <h2 class="h6 mb-3">{{ product.name }}</h2>
                    <img class="product-image mb-3" [src]="imageSource(product.image)" [alt]="product.name" />
                    <table class="table table-sm mb-3"><tbody>
                      <tr>
                        <th>Procesador</th><td>{{ product.processor }}</td>
                        @if (showRelatedImages) { <td class="product-related-image-cell">@if (imageSource(product.processorImage); as image) { <img class="product-related-image" [src]="image" [alt]="product.processor" /> } @else { <i class="bi bi-cpu text-body-secondary"></i> }</td> }
                      </tr>
                      <tr>
                        <th>Tarjeta gráfica</th><td>{{ product.graphicCard }}</td>
                        @if (showRelatedImages) { <td class="product-related-image-cell">@if (imageSource(product.graphicCardImage); as image) { <img class="product-related-image" [src]="image" [alt]="product.graphicCard" /> } @else { <i class="bi bi-gpu-card text-body-secondary"></i> }</td> }
                      </tr>
                      <tr>
                        <th>Sistema operativo</th><td>{{ product.operatingSystem }}</td>
                        @if (showRelatedImages) { <td class="product-related-image-cell">@if (imageSource(product.operatingSystemImage); as image) { <img class="product-related-image" [src]="image" [alt]="product.operatingSystem" /> } @else { <i class="bi bi-windows text-body-secondary"></i> }</td> }
                      </tr>
                      <tr>
                        <th>Precio</th>
                        <td class="fw-semibold" [class.text-decoration-line-through]="hasDiscount(product)" [class.text-body-secondary]="hasDiscount(product)" [class.text-primary]="!hasDiscount(product)">{{ formatPrice(product.price) }}</td>
                        @if (showRelatedImages) { <td></td> }
                      </tr>
                      @if (hasDiscount(product)) {
                        <tr>
                          <th>Descuento</th>
                          <td class="fw-semibold text-danger">{{ formatPrice(discountedPrice(product)) }}</td>
                          <td class="product-related-image-cell"><span class="badge text-bg-danger">-{{ product.discount }}%</span></td>
                        </tr>
                      }
                    </tbody></table>
                    <a class="btn btn-primary w-100 mt-auto" [routerLink]="['/portal/product', product.id]">Detalle</a>
                  </div>
                </article>
              </div>
            } @empty { <p class="text-body-secondary mb-0">No hay productos para la selección actual.</p> }
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
